/**
 * Enum representing different types of messages for the Information list.
 */
export enum InformationListMessageType {
  /**
   * Error message type.
   */
  ERROR = 'ERROR',
  /**
   * Warning message type.
   */
  WARNING = 'WARNING',
}

/**
 * Props for the InformationList component.
 */
export type InformationListProps = {
  /**
   * An array of error messages.
   */
  errors?: string[];
  /**
   * An array of warning messages.
   */
  warnings?: string[];
};
